import { find, isEmpty } from 'lodash-es';
import { hasFeature } from './featureService';

export const hasFlashPrice = (product) => {
  if (!product || !hasFeature('flash_price_campaign')) {
    return false;
  }
  if (product.same_price || !product.variations) {
    return product.has_flash_price;
  }
  return find(product.variations, (variation) => {
    return variation.has_flash_price;
  });
};

export const showMemberPriceTip = (product) => {
  if (
    window.mainConfig.currentUser ||
    !window.mainConfig.merchantData.product_setting.enabled_show_member_price ||
    hasFlashPrice(product)
  ) {
    return false;
  }

  return hasFeature('member_price') && product?.member_price?.cents > 0;
};

export const lowerProductPriceObject = (product) => {
  if (
    product.member_price &&
    product.member_price.cents > 0 &&
    window.mainConfig.currentUser &&
    hasFeature('member_price')
  ) {
    return product.member_price;
  } else if (product.price_sale && product.price_sale.cents > 0) {
    return product.price_sale;
  }
};

export const lowerProductPrice = (product) => {
  return lowerProductPriceObject(product)?.label;
};

export const lowerProductPriceMembersTag = (product) => {
  const hasMemberPrice = hasFeature('member_price');
  const hasTierMemberPrice = hasFeature('tier_member_price');
  if (
    product.member_price &&
    product.member_price.cents > 0 &&
    window.mainConfig.currentUser &&
    hasMemberPrice
  ) {
    let memberOnlyTag = window.shopline.i18next.t('Member Only', {
      ns: 'translation',
    });
    let memberTierPrice =
      window.mainConfig.currentUser && product.product_price_tiers
        ? find(product.product_price_tiers, function (tier) {
            return (
              tier.membership_tier_id ===
              window.mainConfig.currentUser.membership_tier_id
            );
          })
        : null;
    if (
      hasTierMemberPrice &&
      !isEmpty(memberTierPrice?.member_price) &&
      memberTierPrice.member_price.cents > 0
    ) {
      memberOnlyTag = window.shopline.i18next.t('Tier Member Only', {
        ns: 'translation',
        tierName: window.shopline.translateModel(
          window.mainConfig.currentUser.membership_tier.name_translations,
        ),
      });
    }
    return memberOnlyTag;
  }
  return '';
};
